import { get_cookie } from "../helper";

export const getEmail = () => {
    let email = localStorage.getItem('email') ?? get_cookie('email');

    if (email !== undefined && email !== null) {
        try {
            return decodeURIComponent(email);
        } catch (e) {
            return email;
        }
    }

    return null; 
};
